import $ from 'jquery';
import _ from 'underscore';
import * as baseWishlistButtonEvents from '../../tracking/wishlist/baseWishlistButtonEvents';
import * as registry from '../../../home24/core/registry';

export default function WishlistButtonEvents() {

    this.selectors = {
        page: '.js-wishlist-article-list',
        removeButton: '.js-wishlist-article__remove',
        articleParent: '.js-wishlist-article__wrap'
    };

    this.bindEvents();
}

WishlistButtonEvents.prototype = _.extend({}, baseWishlistButtonEvents, {

    bindEvents: function () {
        $(this.selectors.page).on('click.wishlistButtonEvents', this.selectors.removeButton, _.bind(this.onRemoveButtonClick, this));
    },

    onRemoveButtonClick: function (event) {
        var data = this.getTrackingData($(event.currentTarget));

        this.pushRemoveFromWishlistEvent(data);
    },

    getTrackingData: function ($clickedEl) {
        // jquery caches the attribute value if retrieved with .data()
        var sku = $clickedEl.parents(this.selectors.articleParent).attr('data-sku');
        var data = {};
        var dataSource = registry.get('wishlist.trackingData');

        // on wishlist page read from Registry
        if (dataSource && dataSource[sku]) {
            data = dataSource[sku];
        }

        return {
            sku: sku,
            price: data.price || '',
            brand: data.brand || '',
            category: data.category || ''
        };
    },

    destroy: function () {
        $(this.selectors.page).off('click.wishlistButtonEvents');
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/wishlist/wishlistButtonEvents.js
 **/